import type React from "react";
import { styled } from "@mui/material/styles";

const Container = styled("div")({
	height: "100%",
	overflow: "hidden",

	display: "grid",
	gridTemplateRows: "64px 1fr",
});

interface SiteContainerProps {
	readonly header: React.ReactNode;
	readonly children: React.ReactNode;
}

export const SiteContainer: React.FC<SiteContainerProps> = ({ header, children }) => {
	return (
		<Container>
			{header}
			{children}
		</Container>
	);
};
